import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext } from 'react'
import { Button, Card, CardBody } from 'reactstrap'
import { StatusContext } from '../../utility/context/StatusContext'
import { InputFileGroup } from './InputFileGroup'


export const FormDocumention2 = (props) => {
    const { finishOwnerShip } = props
    const [activeIndex, setActiveIndex] = useContext(StatusContext)
    return (
        <>
            <Card>

                <CardBody className='row'>
                    <h3 style={{ fontWeight: 'bold' }}>Adjuntar documentación</h3>
                    <p style={{ fontSize: '13px' }}>Inserta los siguientes documentos:</p>
                    <div>
                        <h4 className='text-center text-bold'>DNI del comprador</h4>
                        <div className='d-flex justify-content-around'>
                            <InputFileGroup name={'buyer_dni_doc_1'} />
                            <InputFileGroup name={'buyer_dni_doc_2'} />
                        </div>
                    </div>
                    <div>
                        <h4 className='text-center text-bold'>Permiso de circulación del vehículo</h4>
                        <div className='d-flex justify-content-around'>
                            <InputFileGroup name={'circulation_doc'} />
                        </div>
                    </div>
                </CardBody>
            </Card>
            <div className='row'>
                <div className='col-6' style={{ textAlign: 'left' }}>
                    <Button onClick={() => setActiveIndex(activeIndex - 1)} color='primary'>Atras <FontAwesomeIcon style={{ marginLeft: '3px' }} icon={faArrowLeft} size={'1x'} /></Button>
                </div>
                <div className='col-6' style={{ textAlign: 'right' }}>
                    <Button onClick={async () => { await finishOwnerShip(); setActiveIndex(activeIndex + 1) }} color='primary'>Realizar Pago  <FontAwesomeIcon style={{ marginLeft: '3px' }} icon={faArrowRight} size={'1x'} /></Button>
                </div>
            </div>
        </>
    )
}
